export const getAuthorizedOperator = (admins, authorizedUserID) => {
  const findedUser = admins.find((admin) => {
    return admin.id === authorizedUserID;
  })
  return findedUser;
}